module.exports = __webpack_public_path__ + "media/src/pages/Onboarding/images/success-1-10638c135b9412a4057c4505c6a4d5e8.png";